import React from 'react'
import styled from 'styled-components'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'
import { media } from 'styles/media'

import Avatar from '../display/Avatar'
import LazyImage from '../display/LazyImage'
import LinkOrA from '../cards/shared/LinkOrA'

const StoryDetail = styled.h5`
  font-size: 14px;

  ${media.md`
    font-size: 20px;
    line-height: 1.4;
  `}
`

const StoryTitle = styled(StoryDetail)`
  font-weight: 300;
  color: ${({ theme }) => theme.brand.jungle};
`

const Storyteller = styled(StoryDetail)`
  font-weight: 200;
  color: ${({ theme }) => theme.colors.textGreyDarker};
`

const StoryCreditOuter = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  text-align: left;

  height: 40px;
  ${media.md`
    height: 90px;
  `}

  ${Avatar} {
    flex-shrink: 0;
    height: 40px;
    width: 40px;
    ${media.md`
      height: 90px;
      width: 90px;
    `}
  }

  ${StoryTitle}, ${Storyteller} {
    margin-bottom: 2px;

    ${media.md`
      margin-bottom: 8px;
    `}
  }
`

type StoryCreditProps = {
  avatar: Partial<GQL_UserAvatar> & { thumbLg: string }
  firstName: string
  storyTitle: string
  storyUrl: string
}

const StoryCredit: React.FC<StoryCreditProps> = ({
  avatar,
  firstName,
  storyTitle,
  storyUrl,
}) => {
  const { md: largerThanMd } = useMediaQueryContext()
  const isSmallerThanMd = !largerThanMd

  return (
    <StoryCreditOuter>
      <Avatar>
        <LazyImage data-src={avatar.thumbLg} />
        <noscript>
          <LazyImage src={avatar.thumbLg} />
        </noscript>
      </Avatar>
      <div>
        <Storyteller>Story by {firstName}</Storyteller>
        <LinkOrA asLink={isSmallerThanMd} to={storyUrl}>
          <StoryTitle>{storyTitle}</StoryTitle>
        </LinkOrA>
      </div>
    </StoryCreditOuter>
  )
}

export default StoryCredit
